import React from "react";
import { MDBBtn, MDBContainer } from "mdb-react-ui-kit";
import { motion } from "framer-motion";
import t from "../utilities/transitions";
import { route, purge_user } from "../redux/actions";
import { connect } from "react-redux";
import LogoLoader from "../components/LogoLoader";
import axios from "axios";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";

class Delete extends React.Component {
  constructor(props) {
    super();
    this.state = {
      error: "",
      working: true,
      attempts: 0,
    };
    this.requestID = props.match.params.id;
  }

  componentDidMount() {
    this.run();
  }

  run = () =>
    axios
      .get(
        process.env.REACT_APP_LAMBDA_AUTH + "/delete-confirm/" + this.requestID
      )
      .then((res) => {
        this.init();
      })
      .catch((err) => {
        console.log(err, err.response?.status);
        if (err.response?.status === 410)
          this.setState((curr) => ({
            ...curr,
            error:
              "This deletion request has expired. If you would still like to delete your account, please submit another request and click the new link that is sent to your email.",
            working: false,
          }));
        else if (err.response?.status === 404)
          this.setState((curr) => ({
            ...curr,
            error: "Deletion request not found.",
            working: false,
          }));
        else if (err.response?.status === 400)
          this.setState((curr) => ({
            ...curr,
            working: false,
            error:
              "This deletion request has been cancelled. If you would still like to delete your account, please submit another request and click the new link that is sent to your email.",
          }));
        else if (this.state.attempts >= 3)
          this.setState((curr) => ({
            ...curr,
            error:
              "An unknown error occurred. Please check your connection and try again later.",
            working: false,
          }));
        else
          this.setState(
            (curr) => ({
              ...curr,
              attempts: this.state.attempts + 1,
            }),
            () => setTimeout(this.run, 1000)
          );
      });

  init = () =>
    axios
      .get(
        process.env.REACT_APP_LAMBDA_AUTH +
          "/init/" +
          this.props.userInfo.userSettings.theme
      )
      .then((res) => {
        this.props.purge_user();
        this.setState((curr) => ({
          ...curr,
          working: false,
        }));
      })
      .catch((err) => {
        console.log("Init error", err);
        console.log("delete reload");
        window.location.reload();
      });

  render() {
    return (
      <motion.div
        transition={t.transition}
        initial={t.fade_out}
        animate={t.normalize}
        exit={t.fade_out_scale_1}
        className="page-container pt-5"
      >
        <MDBContainer>
          {this.state.working ? (
            <motion.section
              transition={t.transition}
              initial={t.fade_out}
              animate={t.normalize}
              exit={t.fade_out_scale_1}
            >
              <h5 className="text-center display-6 my-4">Confirming Request</h5>
              <LogoLoader />
            </motion.section>
          ) : (
            <motion.div
              transition={t.transition}
              initial={t.fade_out}
              animate={t.normalize}
              exit={t.fade_out_scale_1}
              className="mt-5"
            >
              <h5 className="text-center my-4">
                {this.state.error || "Your account was successfully deleted"}
              </h5>
              <MDBBtn
                className="d-block mx-auto"
                rippleColor="primary"
                color="link"
                size="lg"
                onClick={() => this.props.route("/")}
              >
                <i className="fas fa-home me-2" />
                Return
              </MDBBtn>
            </motion.div>
          )}
        </MDBContainer>
      </motion.div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
});

export default connect(mapStateToProps, { route, purge_user })(
  withRouter(Delete)
);
